var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.member)?_c('div',{staticClass:"member-vehicles"},[_c('vehicle-list',{attrs:{"organization-id":_vm.member.organization.id,"organization-name":_vm.member.organization.name,"customer-id":_vm.member.customer.id,"customer-name":_vm.member.customer.firstname + ' ' + _vm.member.customer.lastname,"member-id":_vm.member.id}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }